export interface SokobanLevelDef {
  id: number;
  x: number;
  y: number;
}

const LEVEL_COUNT = 50;
const LEVEL_SPACING = 200;
const MAP_HEIGHT = 566;
const MAP_PADDING_X = 140;
const CENTER_Y = MAP_HEIGHT / 2;

export const SOKOBAN_LEVELS: SokobanLevelDef[] = Array(LEVEL_COUNT)
  .fill(0)
  .map((_, i) => ({
    id: i + 1,
    x: MAP_PADDING_X + i * LEVEL_SPACING,
    y: CENTER_Y + Math.sin(i * 0.9) * 130 + Math.cos(i * 0.4) * 30,
  }));

export const SOKOBAN_MAP_WIDTH = MAP_PADDING_X * 2 + (LEVEL_COUNT - 1) * LEVEL_SPACING;
export const SOKOBAN_MAP_HEIGHT = MAP_HEIGHT;
